import moment from 'moment';

if($('#commenting-component').length){
    var app = new Vue({
        el: '#commenting-component',
        data: {
            showConfirm:false,
            comments: {},
            count: 0,
            model:polymorphicModel,
            modelId:polymorphicId,
            message: '',
            submitting: false,
            loading: true,
            currentUserImage: currentUserImage,
            userId: userId,
            authorId: authorId,
            params: null,
            order: 'newest',
            posting: false,
            currentPage: 1,
            lastPage: 1,
            nextPage: 1
        },
        methods: {
            get(firstLoad, page){
                var user = false;
                if(this.userId){
                    user = true;
                }
                this.loading = true;
                axios.get('/api/v1/comments/'+this.model+'/'+this.modelId+'?page='+page+'&user='+user).then((response) =>  {
                    this.loading = false;
                    if(page > 1){
                        this.$nextTick(() => {
                            this.comments = this.comments.concat(response.data.data);
                            $(".tooltipped").tooltip();
                        });
                    }else{
                        this.comments = response.data.data;
                        $(".tooltipped").tooltip();
                    }
                    this.currentPage = response.data.current_page;
                    this.nextPage = response.data.current_page + 1;
                    this.lastPage = response.data.last_page;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error)
                    this.$toasted.error('There was an error retrieving comments');
                });
            },
            loadMore(){
                this.get(false, this.nextPage);
            },
            getReplies(comment){
                var user = false;
                if(this.userId){
                    user = true;
                }
                axios.get('/api/v1/comments/'+comment.id+'/replies?user'+user).then((response) =>  {
                    this.$nextTick(() => {
                        comment.replies = response.data;
                        comment.show_replies = true;
                        this.$nextTick(() => {
                            comment.comments_count++;
                            comment.comments_count--;
                            this.loading = false;
                        });
                    });
                }).catch(function (error) {
                    console.log(error)
                    this.$toasted.error('There was an error retrieving comments');
                });
            },
            getCount(){
                axios.get('/api/v1/comments/'+this.model+'/'+this.modelId+'/count', {
                    'message':this.message
                }).then((response) =>  {
                    this.$nextTick(() => {
                        this.count = response.data;
                    });
                }).catch(function (error) {
                    console.log(error)
                    this.$toasted.error('There was an error retrieving comments count');
                });
            },
            create(comment){
                let parent_id = null;
                let message = this.message;

                if(comment){
                    parent_id = comment.id;
                    message = comment.sub_text;
                    this.loading = true;
                }else{
                    this.submitting = true
                }

                let token = ''
                if (document.querySelector('textarea[name="h-captcha-response"]')) {
                    token = document.querySelector('textarea[name="h-captcha-response"]').value
                }

                axios.post('/api/v1/comments/'+this.model+'/'+this.modelId+'/create', {
                    'comment_id':parent_id,
                    'message':message,
                    'h-captcha-response':token
                }).then((response) =>  {
                    if (this.model === 'Article') {
                        location.replace("/under-review/comment");
                        return;
                    }
                    this.message = '';
                    if(comment){
                        comment.sub_text = '';
                    }
                    this.submitting = false;
                    this.count ++;
                    if(comment){
                        this.getReplies(comment);
                        comment.comments_count++;
                        this.$toasted.success('Your reply was posted succesfully');
                    }else{
                        this.get(false, 1);
                        this.$toasted.success('Your comment was posted succesfully');
                    }
                }).catch(function (error) {
                    if (error.response.data) {
                        document.getElementById('error-msg').innerText = error.response.data;
                        document.getElementById("error-msg-pop-up").style.display = 'block'
                    } else {
                        console.log(error);
                        this.$toasted.error('There was an error posting your comment');
                    }
                });
                this.submitting = this.loading = false
            },
            deleteComment(comment, reply){
                if(confirm("Are you sure you want to delete this comment?")){

                    var id = comment.id;
                    if(reply){
                        id = reply.id;
                    }
    
                    axios.delete('/api/v1/comments/'+id+'/destroy')
                    .then((response) =>  {
                        if(reply){
                            this.getReplies(comment);
                            comment.comments_count--;
                        }else{
                            this.get(true, 1);
                            this.count--;
                        }
                        this.$toasted.info('Comment deleted');
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                }
            },
            scrollDown(id) {
                this.$nextTick(() => {
                    var container = this.$el.querySelector(".comments-wrapper");
                    container.scrollTop = container.scrollHeight;
                });
            },
            getHtml(inputText) {
                var replacedText, replacePattern1, replacePattern2, replacePattern3;

                //URLs starting with http://, https://, or ftp://
                replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

                //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
                replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

                //Change email addresses to mailto:: links.
                replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            },
            getTime(time){
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('LLL');
            },
            toggleReplies(comment){
                if(!this.userId){
                    window.location = '/register';
                }else{
                    if(!comment.show_replies){
                        this.getReplies(comment);
                    }else{
                        comment.show_replies = false;
                    }
                }
            },
            createLike(comment){
                if(!this.userId){
                    window.location = '/register';
                }else{
                    axios.post('/api/v1/likes/Comment/'+comment.id+'/create')
                    .then((response) =>  {
                        this.$nextTick(() => {
                            comment.liked = true;
                            comment.likes_count ++;
                            this.$nextTick(() => {
                                this.message = 'done';
                                this.message = '';
                                this.getCount();
                            });
                            this.$toasted.success('You have liked the Comment');
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            destroyLike(comment){
                axios.delete('/api/v1/likes/Comment/'+comment.id+'/destroy')
                .then((response) =>  {
                    this.$nextTick(() => {
                        comment.liked = false;
                        comment.likes_count --;
                        this.$nextTick(() => {
                            this.message = 'done';
                            this.message = '';
                        });
                        this.$toasted.info('You have unliked the Comment');
                    });
                })
                .catch(function (error) {
                    console.log(error);
                })
            }
        },
        mounted () {
            this.get(true, 1);
            this.getCount();
        }
    });
}